module.exports = __webpack_public_path__ + "assets/15764ec83209b161bb3207e9bfdc28f4.jpg";